import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../contexts/AuthContext'

const DIAS_SEMANA = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
const MESES_NOME = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro']

function toLocalDate(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number)
  return new Date(y, m - 1, d)
}

function formatarData(dateStr) {
  const d = toLocalDate(dateStr)
  return d.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
}

export default function Reunioes() {
  const { isSuperAdmin, selectedCompany } = useAuth()
  const hoje = new Date()
  const [mes, setMes] = useState(hoje.getMonth())
  const [ano, setAno] = useState(hoje.getFullYear())
  const [reunioes, setReunioes] = useState([])
  const [loading, setLoading] = useState(true)
  const [confirmando, setConfirmando] = useState(null)
  const [erro, setErro] = useState(null)

  useEffect(() => { fetchReunioes() }, [selectedCompany])

  async function fetchReunioes() {
    let q = supabase.from('reunioes').select('id, data').order('data')
    if (isSuperAdmin && selectedCompany) q = q.eq('company_id', selectedCompany.id)
    const { data, error } = await q
    if (error) setErro(error.message)
    setReunioes(data || [])
    setLoading(false)
  }

  // Datas de reunião como Set de strings YYYY-MM-DD
  const datasSet = new Set(reunioes.map(r => r.data))

  function diaPad(n) { return String(n).padStart(2, '0') }
  function toStr(y, m, d) { return `${y}-${diaPad(m + 1)}-${diaPad(d)}` }

  async function toggleDia(dataStr) {
    setErro(null)
    const existente = reunioes.find(r => r.data === dataStr)
    if (existente) {
      setConfirmando(existente)
    } else {
      // Reuniao nao tem responsavel de quem herdar a empresa, e o super_admin
      // nao tem empresa propria: sem uma selecionada a linha nasceria com
      // company_id NULL, visivel so' em "todas as empresas" (ver v1.11).
      if (isSuperAdmin && !selectedCompany) {
        setErro('Selecione uma empresa no topo para marcar a reunião.')
        return
      }
      const novaReuniao = { data: dataStr }
      if (isSuperAdmin && selectedCompany) novaReuniao.company_id = selectedCompany.id
      const { data, error } = await supabase.from('reunioes').insert(novaReuniao).select().single()
      if (error) { setErro(error.message); return }
      if (data) setReunioes(prev => [...prev, data].sort((a, b) => a.data.localeCompare(b.data)))
    }
  }

  async function confirmarRemocao() {
    await supabase.from('reunioes').delete().eq('id', confirmando.id)
    setReunioes(prev => prev.filter(r => r.id !== confirmando.id))
    setConfirmando(null)
  }

  // Calcula células do calendário
  const primeiroDia = new Date(ano, mes, 1).getDay()
  const diasNoMes = new Date(ano, mes + 1, 0).getDate()
  const celulas = [...Array(primeiroDia).fill(null), ...Array.from({ length: diasNoMes }, (_, i) => i + 1)]

  function navMes(delta) {
    const d = new Date(ano, mes + delta, 1)
    setMes(d.getMonth())
    setAno(d.getFullYear())
  }

  const hojeStr = toStr(hoje.getFullYear(), hoje.getMonth(), hoje.getDate())

  const proximas = reunioes.filter(r => r.data >= hojeStr)

  return (
    <div>
      <div className="page-title">
        <div>
          <h2>Reuniões de Indicadores</h2>
          <p style={{ color: 'var(--text2)', fontSize: 13, marginTop: 2 }}>
            Clique em um dia para agendar ou remover uma reunião
          </p>
        </div>
      </div>

      {erro && (
        <div style={{ background: 'var(--red-bg)', border: '1px solid var(--red-border)', color: 'var(--red)', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 13 }}>
          Erro: {erro}
        </div>
      )}

      {confirmando && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }}>
          <div className="card" style={{ maxWidth: 380, width: '100%', textAlign: 'center' }}>
            <p style={{ fontWeight: 600, fontSize: 15, marginBottom: 8 }}>Remover reunião?</p>
            <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 20 }}>
              {formatarData(confirmando.data)}
            </p>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
              <button className="btn btn-sm" style={{ background: 'var(--red)', color: '#fff', borderColor: 'var(--red)' }}
                onClick={confirmarRemocao}>Sim, remover</button>
              <button className="btn btn-sm" onClick={() => setConfirmando(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 260px', gap: 20, alignItems: 'start' }}>
        {/* Calendário */}
        <div className="card">
          {/* Navegação do mês */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
            <button className="btn btn-sm" onClick={() => navMes(-1)}>‹</button>
            <span style={{ fontWeight: 600, fontSize: 15 }}>{MESES_NOME[mes]} {ano}</span>
            <button className="btn btn-sm" onClick={() => navMes(1)}>›</button>
          </div>

          {/* Cabeçalho dias da semana */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4, marginBottom: 4 }}>
            {DIAS_SEMANA.map(d => (
              <div key={d} style={{ textAlign: 'center', fontSize: 11, fontWeight: 600, color: 'var(--text3)', padding: '4px 0' }}>
                {d}
              </div>
            ))}
          </div>

          {/* Células */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4 }}>
            {celulas.map((dia, idx) => {
              if (!dia) return <div key={`e-${idx}`} />
              const dataStr = toStr(ano, mes, dia)
              const temReuniao = datasSet.has(dataStr)
              const isHoje = dataStr === hojeStr
              const passado = dataStr < hojeStr
              return (
                <button
                  key={dia}
                  onClick={() => toggleDia(dataStr)}
                  style={{
                    aspectRatio: '1',
                    borderRadius: 8,
                    border: isHoje ? '2px solid var(--blue)' : temReuniao ? 'none' : '1px solid var(--border)',
                    background: temReuniao ? 'var(--blue)' : 'transparent',
                    color: temReuniao ? '#fff' : passado ? 'var(--text3)' : 'var(--text)',
                    fontWeight: temReuniao || isHoje ? 600 : 400,
                    fontSize: 13,
                    cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}
                >
                  {dia}
                </button>
              )
            })}
          </div>

          <p style={{ fontSize: 11, color: 'var(--text3)', marginTop: 14, textAlign: 'center' }}>
            Dias em azul têm reunião agendada
          </p>
        </div>

        {/* Próximas reuniões */}
        <div className="card" style={{ maxHeight: 520, display: 'flex', flexDirection: 'column' }}>
          <h3 style={{ marginBottom: 14, flexShrink: 0 }}>Próximas reuniões</h3>
          <div style={{ overflowY: 'auto', flex: 1 }}>
          {loading ? (
            <p style={{ color: 'var(--text3)', fontSize: 13 }}>Carregando...</p>
          ) : proximas.length === 0 ? (
            <p style={{ color: 'var(--text3)', fontSize: 13 }}>Nenhuma reunião agendada.</p>
          ) : (
            proximas.map(r => (
              <div key={r.id} style={{
                padding: '8px 10px', borderRadius: 6, marginBottom: 6,
                background: 'var(--surface2)', fontSize: 13
              }}>
                <div style={{ fontWeight: 600 }}>
                  {toLocalDate(r.data).toLocaleDateString('pt-BR', { day: 'numeric', month: 'short' }).replace('.', '')}
                  {' '}
                  <span style={{ fontWeight: 400, color: 'var(--text3)' }}>
                    {toLocalDate(r.data).toLocaleDateString('pt-BR', { weekday: 'short' })}
                  </span>
                </div>
                <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 2 }}>
                  {toLocalDate(r.data).getFullYear()}
                </div>
              </div>
            ))
          )}
          </div>
        </div>
      </div>
    </div>
  )
}
